import script from "./DesktopUncategorisedBulk.vue?vue&type=script&setup=true&lang=ts"
export * from "./DesktopUncategorisedBulk.vue?vue&type=script&setup=true&lang=ts"

import "./DesktopUncategorisedBulk.vue?vue&type=style&index=0&id=a5ebee8e&lang=css"

const __exports__ = script;

export default __exports__